import React, { useEffect, useState } from 'react';
import user from "../../../assets/icons/user.svg";
import edit from "../../../assets/icons/edit.svg";
import { useNavigate } from 'react-router-dom';
import deleteIcon from "../../../assets/icons/delete.svg"

export default function TravellerCard(props){

  const navigate = useNavigate();
  const [guestDetails, setGuestDetails] = useState([]);  


  useEffect(() => {
    const setGuests = () => {
      if (!props.guests[props.rno] || props.guests[props.rno].length === 0) {
        setGuestDetails([]); // No guests available
      } else {
        setGuestDetails(props.guests[props.rno]);
      }
    };
    setGuests();
  }, []);

  const truncateName = (name) => {
    return name.length > 16 ? name.slice(0, 16) + '...' : name;
  };

 
  const handleDeleteUser = (index, rno) => {
  
    // Check if guests exist for the given rno
    if (props.guests[rno] && props.guests[rno].length > 0) {
      // Remove the guest at the specified index
      props.guests[rno].splice(index, 1); // Use '1' to remove a single item
  
      // Update guest details
      setGuestDetails([...props.guests[rno]]);
    } else {
      // If no guests available, set an empty array
      setGuestDetails([]);
    }

  };
 

  const navigateToEdit = (update, index,name,verification_id,contact,email,address,user,is_minor)=>{
    if (update === "updateBooking" && index !== null && index !== undefined) {

      navigate("/editWebCheckIn", {
        // This is for update data
        state: {
          bookedRoomId: props.bookedRoomId,
          update: update,
          index: index,
          name : name,
          verification_id : verification_id,
          contact : user?.contact || contact,
          address : address,
          email : email,
          is_minor : is_minor,
          bookedRooms : props.bookedRooms,
          rno : props.rno,
          guests : props.guests,
          // Hotel View
          hotelId: props.hotelId,
          bookingId: props.bookingId,
          checkInDate : props.checkInDate,
          checkOutDate : props.checkOutDate,
          hotelAddress : props.hotelAddress,
          hotelName : props.hotelName,
          activeTab : props.activeTab,
          status : props.status,
          tags : props.tags,
          timeArrival : props.timeArrival
        },
      });
    }
    else{
      navigate("/editWebCheckIn", {
        state: {
          bookedRoomId: props.bookedRoomId,
          rno : props.rno,
          guests : props.guests,
          bookedRooms : props.bookedRooms,
          
          // For Hotel View
          bookingId: props.bookingId,
          hotelId: props.hotelId,
          checkInDate : props.checkInDate,
          checkOutDate : props.checkOutDate,
          hotelAddress : props.hotelAddress,
          hotelName : props.hotelName,
          activeTab : props.activeTab,
          status : props.status,
          tags : props.tags,
          timeArrival : props.timeArrival
        },
      });
    }
  }



  // Validate the Data
  const isGuestComplete = (guest) => {
    try{
      const guestData = {
        name: guest.name?.trim() || guest.user?.name,
        contact: guest.contact || guest.user?.contact,
        email: guest.email?.trim() || guest.user?.email,
        address: guest.address?.trim() || guest.user?.address,
        verification_id: guest.verification_id || guest.user?.verification_id,
      };
  
      const verificationIds = (guestData.verification_id || "")
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean);
  
      return (
        !!guestData.name?.trim() &&
        !!guestData.contact &&
        !!guestData.email?.trim() &&
        !!guestData.address?.trim() &&
        verificationIds.length === 2
      );
    }catch(error){
      console.log(error);
    }
  };

  return (
    <div className="traveller-card" key={props.index}>
      <div className="traveller-roomId">
        <h4>Room : {props.count}</h4>
      </div>

      {/* For No Guest Show This */}
      {
        props.webCheckIn_status ?       
        
        guestDetails.map((guest, index) => (
            <div className="traveller-name" key={index}>

              {/* Name */}
              <div className="name">
                <h4>{truncateName(guest.name) || "Guest Name"}</h4>
              </div>

              {/* CRUD */}
              <div className="name-edit">
               <div className={(guest.is_minor || isGuestComplete(guest)) ? "traveller-id-uploaded" : "traveller-id"}>
                 <h5>
                    {guest.is_minor
                      ? "Child · under 18"
                      : isGuestComplete(guest)
                      ? "Details Complete"
                      : "Details Missing"}
                  </h5>
                </div>
                {

                  props.room.webCheckIn_time_status ? "" : (
                    <>
                      <div className="edit-icon">
                        <img src={deleteIcon} alt='edit icon' onClick={()=>handleDeleteUser(index,props.rno)}/>
                      </div>
                      <div className="edit-icon">
                        <img src={edit} alt='edit icon' onClick={() => navigateToEdit("updateBooking", index, guest.name, guest.verification_id, guest.contact,guest.email,guest.address,guest?.user,guest.is_minor)} />
                      </div>
                    </>
                  )
                }

              </div>

            </div>
        )) :
        guestDetails.length === 0 ?(
        <div className="no-guests" style={{ textAlign: 'center', paddingTop: '4px', paddingBottom: '4px',fontSize :"12px" }}>
          No guest details available
        </div>
        ):(

          guestDetails.map((guest, index) => (
            <div className="traveller-name" key={index}>

              {/* Name */}
              <div className="name">
                <h4>{truncateName(guest.name) || "Guest Name"}</h4>
              </div>

              {/* CRUD */}
              <div className="name-edit">
                <div className={(guest.is_minor || guest.verification_id !== "") ? "traveller-id-uploaded" : "traveller-id"}>
                  <h5>
                    {guest.is_minor
                      ? "Child · under 18"
                      : isGuestComplete(guest)
                      ? "Details Complete"
                      : "Details Missing"}
                  </h5>
                </div>
                {

                  props.room.webCheckIn_time_status ? "" : (
                    <>
                      <div className="edit-icon">
                        <img src={deleteIcon} alt='edit icon' onClick={()=>handleDeleteUser(index,props.rno)}/>
                      </div>
                      <div className="edit-icon">
                        <img src={edit} alt='edit icon' onClick={() => navigateToEdit("updateBooking", index, guest.name, guest.verification_id, guest.contact,guest.email,guest.address,guest?.user,guest.is_minor)} />
                      </div>
                    </>
                  )
                }

              </div>

            </div>
          ))
        )
      }

  

      {/* Button to Add Guest */}
      <div className='traveller-btn'>
      {
                   
        props.room.webCheckIn_time_status ? "" : (
          <button onClick={() => navigateToEdit()}>
            Add guest to the room
            <img src={user} alt='user icon' />
          </button>
        )
                  
      }
        
      </div>
 
    </div>
  )
}
